/* ===== Viora DeepCalm Theme JS ===== */

document.addEventListener('DOMContentLoaded', function() {

  /* ===== COUNTDOWN TIMER ===== */
  var ch = document.getElementById('cd-h');
  var cm = document.getElementById('cd-m');
  var cs = document.getElementById('cd-s');
  if (ch && cm && cs) {
    setInterval(function() {
      var h = parseInt(ch.textContent), m = parseInt(cm.textContent), s = parseInt(cs.textContent);
      s--;
      if (s < 0) { s = 59; m--; }
      if (m < 0) { m = 59; h--; }
      if (h < 0) { h = 23; m = 59; s = 59; }
      ch.textContent = String(h).padStart(2, '0');
      cm.textContent = String(m).padStart(2, '0');
      cs.textContent = String(s).padStart(2, '0');
    }, 1000);
  }

  /* ===== GALLERY IMAGE SWAP ===== */
  document.querySelectorAll('.gallery-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var src = thumb.getAttribute('data-img-src');
      if (!src) {
        var img = thumb.querySelector('img');
        if (img) src = img.src;
      }
      if (src) {
        // Check if thumb specifies a target, otherwise default to hero main
        var targetId = thumb.getAttribute('data-target') || 'mainImgSrc';
        var mainImg = document.getElementById(targetId);
        if (mainImg) mainImg.src = src;
      }
      // Only toggle active state within the same thumb group
      var parent = thumb.closest('.gallery-thumbs');
      if (parent) {
        parent.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
      }
      thumb.classList.add('active');
    });
  });

  /* ===== OFFER TIER SELECTION ===== */
  document.querySelectorAll('.tier').forEach(function(tier) {
    tier.addEventListener('click', function() {
      // Visual selection
      document.querySelectorAll('.tier').forEach(function(t) { t.classList.remove('sel'); });
      tier.classList.add('sel');

      // Update variant ID if tier has one
      var variantId = tier.getAttribute('data-variant-id');
      var variantInput = document.getElementById('viora-variant-id');
      if (variantId && variantInput) {
        variantInput.value = variantId;
      }

      // Update quantity if tier specifies one
      var qty = tier.getAttribute('data-quantity');
      var qtyInput = document.querySelector('#viora-atc-form input[name="quantity"]');
      if (qty && qtyInput) {
        qtyInput.value = qty;
      }
    });
  });

  /* ===== VARIANT OPTION BUTTONS ===== */
  document.querySelectorAll('.viora-opt-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var idx = parseInt(btn.getAttribute('data-option-idx'));
      var value = btn.getAttribute('data-value');

      // Visual toggle within same option group
      var parent = btn.parentElement;
      parent.querySelectorAll('.viora-opt-btn').forEach(function(b) {
        b.classList.remove('selected');
        b.style.borderColor = 'var(--bd)';
        b.style.background = '#fff';
      });
      btn.classList.add('selected');
      btn.style.borderColor = 'var(--plum)';
      btn.style.background = 'var(--plum-l)';

      // Find matching variant
      var sectionEl = btn.closest('[data-section-id]');
      if (!sectionEl) return;
      var sectionId = sectionEl.getAttribute('data-section-id');
      var variantsJson = document.getElementById('viora-variants-' + sectionId);
      if (!variantsJson) return;

      try {
        var variants = JSON.parse(variantsJson.textContent);
        // Build selected options array
        var selectedOptions = [];
        sectionEl.querySelectorAll('.viora-opt-btn.selected').forEach(function(sel) {
          selectedOptions[parseInt(sel.getAttribute('data-option-idx'))] = sel.getAttribute('data-value');
        });

        // Find variant that matches all selected options
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < selectedOptions.length; j++) {
            if (selectedOptions[j] && v['option' + (j + 1)] !== selectedOptions[j]) {
              match = false;
              break;
            }
          }
          if (match) {
            var variantInput = document.getElementById('viora-variant-id');
            if (variantInput) variantInput.value = v.id;

            // Update price display
            var priceDisplay = sectionEl.querySelector('.viora-live-price');
            if (priceDisplay) {
              var priceHtml = '<span style="font-size:20px;font-weight:800;color:var(--bk)">' + formatMoney(v.price) + '</span>';
              if (v.compare_at_price && v.compare_at_price > v.price) {
                priceHtml += ' <span style="font-size:14px;color:var(--gy);text-decoration:line-through;margin-left:8px">' + formatMoney(v.compare_at_price) + '</span>';
                var savings = v.compare_at_price - v.price;
                priceHtml += ' <span style="font-size:12px;background:var(--gn-l);color:var(--gn);padding:3px 8px;border-radius:4px;font-weight:700;margin-left:8px">Save ' + formatMoney(savings) + '</span>';
              }
              priceDisplay.innerHTML = priceHtml;
            }

            // Update button availability
            var addBtn = sectionEl.querySelector('.cta-button');
            if (addBtn) {
              if (v.available) {
                addBtn.disabled = false;
                addBtn.textContent = 'ADD TO CART';
              } else {
                addBtn.disabled = true;
                addBtn.textContent = 'SOLD OUT';
              }
            }
            break;
          }
        }
      } catch(e) {
        console.error('Variant matching error:', e);
      }
    });
  });

  /* ===== ADD TO CART — handled by cart-drawer.liquid ===== */
  /* The cart drawer intercepts all form[action="/cart/add"] submissions */
  /* and opens the side cart automatically. No duplicate handler needed here. */

  /* ===== ACCORDION ===== */
  document.querySelectorAll('.accordion-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      trigger.closest('.accordion-item').classList.toggle('open');
    });
  });

  /* ===== HELPER: FORMAT MONEY ===== */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

});
